/* @refresh reset */
/**
 * Column factory for CustomServerSideTable. This module is not a "components only" file;
 * `@refresh reset` tells React Fast Refresh to reload the route when this file changes (see Vite
 * plugin-react: consistent components exports).
 */
import React from "react";
import { ColumnTypes, FilterTypes } from "commons/table/Constants";
import {
  CALL_GROUP_TYPE_MULTI_OPTIONS,
  OUTBOUND_STATUS_MULTI_OPTIONS,
  OUTCOME_TAG_MULTI_OPTIONS,
  SWITCH_WF_STATUS_MULTI_OPTIONS,
} from "./aiCallLogConstants";
import {
  AiCallLogCallGroupTypeCell,
  AiCallLogDateTimeCell,
  AiCallLogInfoCell,
  AiCallLogSwitchesCell,
  AiCallLogOutcomeTagsCell,
  AiCallLogOutboundStatusCell,
  AiCallLogStringListCell,
} from "./AiCallLogColumnCells";

export default function createAiCallLogColumns() {
  return [
    {
      header: "Call SID",
      accessor: "callSid",
      accessorKey: "callSid",
      size: 200,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: false,
      columnType: ColumnTypes.Text,
    },
    {
      header: "Switches",
      accessor: "switchInfoIds",
      accessorKey: "switchInfoIds",
      size: 280,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnExternalFilter: true,
      columnType: ColumnTypes.Custom,
      filterType: FilterTypes.SearchableInput,
      customComponent: (value) => <AiCallLogSwitchesCell value={value} />,
    },
    {
      header: "Call Group Type",
      accessor: "callGroupType",
      accessorKey: "callGroupType",
      size: 130,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnExternalFilter: true,
      columnType: ColumnTypes.Custom,
      filterType: FilterTypes.MultiSelect,
      filterOptions: CALL_GROUP_TYPE_MULTI_OPTIONS,
      customComponent: (value) => <AiCallLogCallGroupTypeCell value={value} />,
    },
    {
      header: "Status",
      accessor: "outboundCallStatus",
      accessorKey: "outboundCallStatus",
      size: 120,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnExternalFilter: true,
      columnType: ColumnTypes.Custom,
      filterType: FilterTypes.MultiSelect,
      filterOptions: OUTBOUND_STATUS_MULTI_OPTIONS,
      customComponent: (value) => <AiCallLogOutboundStatusCell value={value} />,
    },
    {
      header: "Switch Status",
      accessor: "switchStatuses",
      accessorKey: "switchStatuses",
      size: 200,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnExternalFilter: true,
      columnType: ColumnTypes.Custom,
      filterType: FilterTypes.MultiSelect,
      filterOptions: SWITCH_WF_STATUS_MULTI_OPTIONS,
      customComponent: (value) => <AiCallLogStringListCell value={value} badgeBg="info" />,
    },
    {
      header: "Tags",
      accessor: "outcomeTags",
      accessorKey: "outcomeTags",
      size: 220,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnExternalFilter: true,
      columnType: ColumnTypes.Custom,
      filterType: FilterTypes.MultiSelect,
      filterOptions: OUTCOME_TAG_MULTI_OPTIONS,
      customComponent: (value) => <AiCallLogOutcomeTagsCell value={value} />,
    },
    {
      header: "Outbound Phone #",
      accessor: "outboundPhoneNumber",
      accessorKey: "outboundPhoneNumber",
      size: 140,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnExternalFilter: true,
      columnType: ColumnTypes.Text,
      filterType: FilterTypes.SearchableInput,
    },
    {
      header: "NPI",
      accessor: "prescriberNpi",
      accessorKey: "prescriberNpi",
      size: 120,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnExternalFilter: true,
      columnType: ColumnTypes.Text,
      filterType: FilterTypes.SearchableInput,
    },
    {
      header: "Creation Time",
      accessor: "creationTime",
      accessorKey: "creationTime",
      size: 155,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnExternalFilter: true,
      columnType: ColumnTypes.Custom,
      filterType: FilterTypes.DateRangePicker,
      placeDatePickerAtEnd: true,
      customComponent: (value) => <AiCallLogDateTimeCell value={value} />,
    },
    {
      header: "Update Time",
      accessor: "updateTime",
      accessorKey: "updateTime",
      size: 155,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnExternalFilter: true,
      columnType: ColumnTypes.Custom,
      filterType: FilterTypes.DateRangePicker,
      placeDatePickerAtEnd: true,
      customComponent: (value) => <AiCallLogDateTimeCell value={value} />,
    },
    {
      header: "",
      accessor: "_aiCallLogInfo",
      accessorKey: "_aiCallLogInfo",
      size: 56,
      canSort: false,
      enableSorting: false,
      enableColumnFilter: false,
      columnType: ColumnTypes.Custom,
      customComponent: (_value, row) => <AiCallLogInfoCell row={row} />,
    },
  ];
}
